import slice from "./billingSlice";

export default slice.reducer;
